import React, { Component } from 'react';
import { Chart } from 'react-google-charts';
import "./CompanyDetailsTab.css";

class CustomChart extends Component {
  constructor(props) {
    super(props);
    this.chartContainerRef = React.createRef();
  }

  componentDidMount() {
    this.addChartEventListeners();
  }

  addChartEventListeners() {
    const chartContainer = this.chartContainerRef.current;

    if (chartContainer) {
      chartContainer.addEventListener('mouseover', this.handleMouseOver);
      chartContainer.addEventListener('mouseout', this.handleMouseOut);
    }
  }

  handleMouseOver = (event) => {
  //  console.log("UUUUUUUU",event.target.classList.contains('campaign_data_graph2'))
        event.target.classList.add('legend-item-hovered');
  };

  handleMouseOut = (event) => {
    // Handle mouseout event here
    event.target.classList.remove('legend-item-hovered');
  };

  componentWillUnmount() {
    this.removeChartEventListeners();
  }

  removeChartEventListeners() {
    const chartContainer = this.chartContainerRef.current;

    if (chartContainer) {
      chartContainer.removeEventListener('mouseover', this.handleMouseOver);
      chartContainer.removeEventListener('mouseout', this.handleMouseOut);
    }
  }

  render() {
    const { data, options } = this.props;

    return (
      <div ref={this.chartContainerRef} className="campaign_data_graph2">
        <Chart
          chartType="PieChart"
          data={data}
          options={options}
          width="100%"
          height="440px"
        />
      </div>
    );
  }
}

export default CustomChart;
